import { CONTENT } from '../content/runtime.js';
import { GROUND_FRAMES } from './gateflow.js';
import type { StationData, OperationsSave, PlaneData, TerminalEconomyData } from './types.js';
export const PHASE = { BOARDING: 0, TAXI: 1, AIRBORNE: 2, APPROACH: 3, READY: 4 } as const;
export const SCHEDULES = CONTENT.operations.schedules;
export const ROUTES = CONTENT.operations.routes;
export function pilotCost(count: number): number {
    const costs = CONTENT.operations.pilotCosts;
    return Number.isInteger(count) && count >= 0 && count < costs.length ? costs[count] : Infinity;
}
export function routeRequirement(index: number, e: TerminalEconomyData, ss: StationData[]): string {
    const r = ROUTES[index];
    if (!r) return 'Unknown destination.';
    if (e.pilotCount < r.requiredPilots) return `Hire ${r.requiredPilots} pilots first.`;
    if (e.flights < r.requiredFlights) return `Complete ${r.requiredFlights} departures first.`;
    if (r.international && !ss[3].unlocked) return 'Open Passport Control.';
    if (r.international && !ss[7].unlocked) return 'Open Flight Dispatch.';
    return '';
}
export function freshPlane(gate: number): PlaneData {
    return { visiting: false, gate, phase: 0, clock: 0, boarded: 0, seats: ROUTES[0].seats, flightNumber: 101 + gate * 100, routeIndex: 0, tripFrames: ROUTES[0].flightFrames, scheduleFrames: 0, nextDepartureFrame: 0, plannedRoute: -1, plannedSchedule: 0 };
}
export function freshOperations(gates = 1): OperationsSave {
    return { routes: ROUTES.map((r, index) => ({ index, unlocked: index === 0, demand: index === 0 ? r.seats * 3 : 0, demandClock: 0, flights: 0 })), pilots: [], planes: Array.from({ length: gates }, (_, gate) => freshPlane(gate)) };
}
export function phaseName(p: PlaneData): string {
    return p.phase === 0 ? 'Boarding' : p.phase === 4 ? 'Full · waiting for pilot' : p.phase === 1 ? 'Taxiing' : p.phase === 2 ? 'In flight' : 'Returning';
}
export function remainingTripFrames(p: Pick<PlaneData, 'phase' | 'clock' | 'tripFrames' | 'expectedArrivalFrame'>, frame?: number): number {
    if (frame !== undefined && p.phase > 0 && p.phase < 4 && p.expectedArrivalFrame !== undefined && p.expectedArrivalFrame >= 0) return Math.max(0, p.expectedArrivalFrame - frame);
    return p.phase === 1 ? GROUND_FRAMES - p.clock + p.tripFrames + GROUND_FRAMES : p.phase === 2 ? Math.max(0, p.tripFrames - p.clock) + GROUND_FRAMES : p.phase === 3 ? Math.max(0, GROUND_FRAMES - p.clock) : 0;
}
